import { Component } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  cardOutline,
  logoAngular,
  logoCapacitor,
  logoFirebase,
  logoPython,
  shieldCheckmarkOutline,
  trendingUpOutline,
} from 'ionicons/icons';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';

addIcons({
  logoAngular,
  logoCapacitor,
  logoPython,
  logoFirebase,
  cardOutline,
  shieldCheckmarkOutline,
  trendingUpOutline,
});

@Component({
  selector: 'app-about-technical',
  standalone: true,
  imports: [UnauthenticatedPageComponent, IonIcon],
  templateUrl: './about-technical.component.html',
  styleUrls: ['./about-project.component.css', './about-technical.component.css'],
})
export class AboutTechnicalComponent {
  readonly pageTitle = 'Technical details';
}
